import React, { useState } from "react";

import TextField from "@mui/material/TextField";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { UserListItem } from "@beable/roster-backend-client-v1";
import { SiteDTO } from "@beable/roster-backend-client-v1";

import CustomerAndSiteSelector from "../Common/CustomerAndSiteSelector";
import Header from "../Header/Header";
import dataViewService from "../../services/DataViewService";
import SchoolAccordion from "./SchoolAccordion";
import { getStyles } from "./styles";
import UsersModal from "./UsersModal";
import AdminsAccordion from "./AdminsAccordion";
import BasePanel from "../Common/Layout/BasePanel";
import { BasePanelBox } from "../Common/Layout/BasePanelBox";
import BaseSheet from "../Common/Layout/BaseSheet";
import { StyledPanelHeader } from "../Common/Layout/PanelHeader";

let initialSelectedSiteValue: SiteDTO;

export default function DataViewPage() {
  const theme = useTheme();
  const styles = getStyles(theme);

  const [selectedSite, setSelectedsite] = useState<SiteDTO | null>(null);
  const [usersModalOpened, setUsersModalOpened] = useState(false);
  const [isUsersLoading, setIsUsersLoading] = useState(false);
  const [teachersList, setTeachersList] = useState<UserListItem[]>([]);
  const [studentsList, setStudentsList] = useState<UserListItem[]>([]);
  const [adminsList, setAdminsList] = useState<UserListItem[]>([]);
//   const [userSearchString, setUserSearchString] = useState('');

  const handleSelectedSiteChange = async (site: any) => {
    if(site) {
        setSelectedsite(site);
    }
  };

  const handleClassSelect = async (
    schoolId: string,
    classId: string,
    event: any
  ) => {
    setIsUsersLoading(true);
    const classWithUsers = await dataViewService.getClassWithStudentsAndteachers(
      selectedSite!.id,
      schoolId,
      classId
    );
    setIsUsersLoading(false);

    if (classWithUsers && classWithUsers.teachers && classWithUsers.students) {
      if (
        classWithUsers.teachers.length === 0 &&
        classWithUsers.students.length === 0
      ) {
        setTeachersList([]);
        setStudentsList([]);
        alert("No users in this class...");
      } else {
        setTeachersList(classWithUsers.teachers);
        setStudentsList(classWithUsers.students);
        setUsersModalOpened(true);
      }
    } else {
      alert("Could not get the users. Please contact support...");
    }
  };

  const handleUserDetailsModalClose = () => {
    setUsersModalOpened(false);
  };

//   const openUserDetailsModal = async (userId: string) => {
//     setIsUserDetailsLoading(true);
//     setUserDetailsModalOpened(true);

//     const userDetails = await dataViewService.getUserDetails(userId);
//     if(userDetails)
//     setuserDetails(userDetails);
//     else
//     alert("Could not get the user details...")

//     setIsUserDetailsLoading(false);
//   }

//   const handleUserSearchStringChange = (event: any) => {
//     const newValue = event.target.value;
//     setUserSearchString(newValue);
//   }

  const searchForUser = async (event: any) => {
    if (event.key === "Enter" && event.target.value.length < 2) {
      alert("Please enter at least 2 characters to search by...");
      return;
    }
    if (event.key === "Enter") {
      setIsUsersLoading(true);

      const usersSearchResp = await dataViewService.searchUsersByUsernameOrName(
        selectedSite!.id,
        event.target.value
      );
      if (usersSearchResp && usersSearchResp.users.length > 0) {
        const teachers: UserListItem[] = [];
        const students: UserListItem[] = [];
        const admins: UserListItem[] = [];

        usersSearchResp.users.forEach((user) => {
          if (user.role === "teacher") teachers.push(user);
          if (user.role === "student") students.push(user);
          if (user.role === "administrator") admins.push(user);
        });

        setTeachersList(teachers);
        setStudentsList(students);
        setAdminsList(admins);
        setUsersModalOpened(true);
        if (usersSearchResp.totalUsers > 100)
          alert(
            `${usersSearchResp.totalUsers} users match the criteria. Please use more specific search input! Showing the first 100 results only`
          );
      }

      if (usersSearchResp && usersSearchResp.users.length === 0) {
        setTeachersList([]);
        setStudentsList([]);
        setAdminsList([]);
        setIsUsersLoading(false);
        alert("No users found...");
      }

      if (!usersSearchResp) {
        setTeachersList([]);
        setStudentsList([]);
        setAdminsList([]);
        setIsUsersLoading(false);
        alert("Search failed. Please contact support.");
      }

      setIsUsersLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Grid container>
        <BasePanel>
          <BasePanelBox>
            <StyledPanelHeader header="Roster View" />
            <Grid container size={12}>
              <CustomerAndSiteSelector onSiteSelect={handleSelectedSiteChange} />
            </Grid>
          </BasePanelBox>
        </BasePanel>
        <BaseSheet maxWidth="lg">
          {selectedSite ? (
            <Grid container size={12}>
              <Grid size={12}>
                <Grid>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    data-testid="input-lookup-username"
                    id="lookup"
                    label="Search by username, firstname or lastname"
                    name="lookupUser"
                    onKeyDown={searchForUser}
                    disabled={isUsersLoading}
                  />
                </Grid>
              </Grid>
              <Grid sx={styles.mt10} size={12}>
                    <AdminsAccordion siteId={selectedSite.id}/>
                    <SchoolAccordion
                      siteId={selectedSite.id}
                      handleClassSelect={handleClassSelect}
                    />
              </Grid>
            </Grid>
          ) : null}
        </BaseSheet>
      </Grid>
      {selectedSite && (
        <UsersModal
          open={usersModalOpened}
          handleClose={handleUserDetailsModalClose}
          teachers={teachersList}
          students={studentsList}
          admins={adminsList}
          siteId={selectedSite.id}
        />
      )}
    </>
  );
}
